import React from 'react';
import {Table} from '../../../components/table/Table';
import {useInvoke} from '../../../controllers/useInvoke';

const TITLE = {
  field: 'image_title',
  header: 'Title',
};

const CREATEDON = {
  type: 'date',
  field: 'created_on',
  header: 'Created On',
};

const COMPLETEDON = {
  type: 'date',
  field: 'completed_date',
  header: 'Completed Date',
};

export const ImageActiveTable = props => {
  const {
    route: {params},
    navigation,
    searchValue,
  } = props;
  const {communicationFilter} = params;
  const invoke = useInvoke({method: 'put'});
  const markComplete = ({row}) => {
    invoke({
      uri: `/images/${row?._id}`,
      props: {
        status: 'completed',
        completed_date: new Date(),
      },
    });
  };
  return (
    <Table
      api={`/image-ads`}
      addOnFilter={{
        status: 'active',
        ...communicationFilter,
      }}
      search={searchValue}
      searchFields={'image_title'}
      params={params}
      onRowPress={row => {
        navigation.navigate('edit-image-ad', row);
      }}
      columns={[TITLE, CREATEDON]}
      moreActions={[
        {
          title: 'Mark Completed',
          onPress: markComplete,
        },
      ]}
    />
  );
};

export const ImageCompletedTable = ({route: {params}, searchValue}) => {
  const {communicationFilter} = params;
  return (
    <Table
      api={`/image-ads`}
      addOnFilter={{
        status: 'completed',
        ...communicationFilter,
      }}
      search={searchValue}
      searchFields={'image_title'}
      params={params}
      columns={[TITLE, CREATEDON, COMPLETEDON]}
    />
  );
};
